import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListGroups = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/groups`, {params});
};

export {
    getListGroups
}